// PaginationBlock.js — shared компонент пагінації (номери сторінок + jump-to-page)
// Винесено з App.js (сесія 2026-08-06) — раніше жив лише там, для результатів
// пошуку; тепер переюзається і в JournalPage.js (пагінація років/номерів журналу)

import React, { useState } from 'react';
import { t } from '../i18n';

export default function PaginationBlock({ page, totalPages, onGo, className = '', lang }) {
  const [jumpVal, setJumpVal] = useState('');

  const handleJump = () => {
    const p = parseInt(jumpVal, 10);
    if (p >= 1 && p <= totalPages && p !== page) { onGo(p); setJumpVal(''); }
  };

  // Будуємо масив сторінок з "..."
  const buildPages = () => {
    if (totalPages <= 11) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const delta = 4;
    const rangeStart = Math.max(2, page - delta);
    const rangeEnd   = Math.min(totalPages - 1, page + delta);
    const pages = [1];
    if (rangeStart > 2)            pages.push('…');
    for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
    if (rangeEnd < totalPages - 1) pages.push('…');
    pages.push(totalPages);
    return pages;
  };

  return (
    <div className={`pagination-block ${className}`}>
      <div className="pagination-controls">
        <button className="pagination-btn pagination-btn--nav"
          disabled={page <= 1} onClick={() => onGo(page - 1)}
          title={t(lang, 'prev')}>
          <i className="fa-solid fa-chevron-left" />
          <span className="pagination-nav-label">{t(lang, 'prev')}</span>
        </button>

        {buildPages().map((p, i) =>
          p === '…' ? (
            <span key={`ell-${i}`} className="pagination-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pagination-page-btn${p === page ? ' pagination-page-btn--active' : ''}`}
              onClick={() => p !== page && onGo(p)}
              disabled={p === page}
            >{p}</button>
          )
        )}

        <button className="pagination-btn pagination-btn--nav"
          disabled={page >= totalPages} onClick={() => onGo(page + 1)}
          title={t(lang, 'next')}>
          <span className="pagination-nav-label">{t(lang, 'next')}</span>
          <i className="fa-solid fa-chevron-right" />
        </button>
      </div>

      <div className="pagination-jumper">
        <span className="pagination-jumper-label">{t(lang, 'page_label')}</span>
        <input
          type="number" min={1} max={totalPages}
          value={jumpVal}
          onChange={e => setJumpVal(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleJump()}
          placeholder={String(page)}
          className="pagination-jump-input"
          aria-label={t(lang, 'page_label')}
        />
        <span className="pagination-jumper-label">{t(lang, 'of')} {totalPages}</span>
        <button
          className="pagination-jump-btn"
          onClick={handleJump}
          disabled={!jumpVal || parseInt(jumpVal,10) === page}
        >{t(lang, 'go_btn')}</button>
      </div>
    </div>
  );
}
